import { useTranslation } from 'react-i18next';
import { AddProductSteps } from '../../../../enums';
import { resources } from '../../../../resources/resources';

interface ProgressBarProps {
  activeStep: AddProductSteps;
}

export const ProgressBar = (props: ProgressBarProps) => {
  const { activeStep } = props;
  const { t: translate } = useTranslation();
  return (
    <ul className="product-steps">
      <li
        className={
          activeStep >= AddProductSteps.ProductType
            ? 'product-step-complete'
            : ''
        }
      >
        <span>{translate(resources.products.add.progressBar.productType)}</span>
      </li>
      <li
        className={
          activeStep >= AddProductSteps.ProductDetails
            ? 'product-step-complete'
            : ''
        }
      >
        <span>{translate(resources.products.add.progressBar.description)}</span>
      </li>
      <li
        className={
          activeStep >= AddProductSteps.OfferDetails
            ? 'product-step-complete'
            : ''
        }
      >
        <span>{translate(resources.products.add.progressBar.price)}</span>
      </li>
      <li
        className={
          activeStep >= AddProductSteps.Translation
            ? 'product-step-complete'
            : ''
        }
      >
        <span>{translate(resources.products.add.progressBar.translation)}</span>
      </li>
    </ul>
  );
};
